export function getKakaoAppKey() {
  return (
    process.env.VUE_APP_KAKAO_APP_KEY_WEB ||
    process.env.NEXT_PUBLIC_KAKAO_APP_KEY_WEB ||
    ""
  );
}

export function initKakaoSdk() {
  if (typeof window === "undefined") {
    return false;
  }

  const kakao = window.Kakao;
  const appKey = getKakaoAppKey();

  if (!kakao || typeof kakao.init !== "function") {
    return false;
  }

  if (!appKey) {
    console.warn("[auth] Kakao app key is not set. Skipping Kakao.init().");
    return false;
  }

  if (typeof kakao.isInitialized === "function" && kakao.isInitialized()) {
    return true;
  }

  kakao.init(appKey);
  return typeof kakao.isInitialized === "function"
    ? kakao.isInitialized()
    : true;
}
